export default __webpack_public_path__ + "static/media/Head_1_Ear_3_C4.3afb6f7f.svg";